import { getLocalStorage } from "./getLocalStorage";

export const setLocalStorage = (obj) =>
  localStorage.setItem("generic", JSON.stringify(obj));

export const setLocalStorageItem = (item, value) => {
  const ls = getLocalStorage();
  ls[item] = value;
  setLocalStorage(ls);
};
